// Keep one lock across game views. Unsupported browsers simply do nothing.
export function startScreenWakeLock({ navigator, document } = globalThis) {
    if (!navigator?.wakeLock?.request) return () => {};

    let lock = null;
    let pending = false;
    let stopped = false;

    async function release(sentinel) {
        try {
            await sentinel.release();
        } catch (error) {
            console.warn('No se pudo liberar Screen Wake Lock:', error);
        }
    }

    function releaseCurrent() {
        const sentinel = lock;
        lock = null;
        if (sentinel) void release(sentinel);
    }

    async function acquire() {
        if (stopped || pending || document.visibilityState !== 'visible' || (lock && !lock.released)) return;
        pending = true;
        try {
            const sentinel = await navigator.wakeLock.request('screen');
            // The view may have been closed or hidden while permission was pending.
            if (stopped || document.visibilityState !== 'visible') {
                await release(sentinel);
                return;
            }
            lock = sentinel;
            sentinel.addEventListener('release', () => {
                if (lock === sentinel) lock = null;
            }, { once: true });
        } catch (error) {
            // Battery saving, permissions or browser policies can deny the request.
            console.warn('No se pudo activar Screen Wake Lock:', error);
        } finally {
            pending = false;
        }
    }

    function onVisibilityChange() {
        if (document.visibilityState === 'visible') void acquire();
        else releaseCurrent();
    }

    document.addEventListener('visibilitychange', onVisibilityChange);
    void acquire();

    return function stopScreenWakeLock() {
        stopped = true;
        document.removeEventListener('visibilitychange', onVisibilityChange);
        releaseCurrent();
    };
}
